import common from './common'
import Draggable from './Draggable'
import expenses from './expenses'
import footerDeleteAccount from './footerDeleteAccount'
import footerPrivacy from './footerPrivacy'
import frame from './frame'
import connection from './connection'
import privateCareer from './privateCareer'
import privateHome from './privateHome'
import privateTodo from './privateTodo'
import what from './what'

export const supportedLanguages = ['FR', 'EN', 'ES', 'PT']

let main = {
    LANG: {
        FR: 'Français',
        EN: 'English',
        ES: 'Español',
        PT: 'Portugués',
    }
}

supportedLanguages.forEach((language) => {
    main[language] = {
        ...main[language],
        ...common[language],
        ...Draggable[language],
        ...expenses[language],
        ...footerDeleteAccount[language],
        ...footerPrivacy[language],
        ...frame[language],
        ...connection[language],
        ...privateCareer[language],
        ...privateHome[language],
        ...privateTodo[language],
        ...what[language],
    }
})

console.log(main)

export default main
